<tax-page-header titleText="kkms.title" [rightSide]="headerButtons"></tax-page-header>
<ng-template #headerButtons>
  <tax-kkm-register-methods
    [hasRetailPlace]="!!(retailPlaces$ | async)?.length"
  ></tax-kkm-register-methods>
</ng-template>

<tax-input
  placeholder="retail.place.placeholder"
  [(ngModel)]="searchField"
  (keydown.enter)="events.searchChange$.next()"
  [clearable]="true"
  (cleanEvent)="resetSearch()"
  data-qa-input="search"
></tax-input>

<div class="sort-list" data-qa="sort-list">
  <span
    *ngFor="let sortItem of sortArray"
    (click)="this.events.sort$.next(sortItem.value)"
    class="sort-item"
    data-qa="sort-item"
  >
    <span [attr.data-qa-sort-item]="sortItem.value" class="item-name">{{
      sortItem.name | translate
    }}</span>
    <svg-icon
      key="sort"
      class="sort-icon"
      [class.desc]="sorting.sortingDirection === 'desc'"
      [class.ui-kit-hidden]="!sorting.sortingDirection || sortItem.value !== sorting.sortField"
    ></svg-icon>
  </span>
</div>

<div class="retail-places-wrapper">
  <div
    class="retail-places"
    data-qa="retail-place-list"
    *ngIf="retailPlaces$ | async as retailPlaces"
  >
    <div *ngIf="retailPlaces.length; else listIsEmpty" (taxElementShow)="scrollToPosition()">
      <div *ngFor="let retailPlace of retailPlaces">
        <tax-retail-place
          [routerLink]="['retailPlace/' + retailPlace.id]"
          [retailPlace]="retailPlace"
          [isSaveRolledUpState]="true"
          data-qa-link="retail-place-page"
        ></tax-retail-place>
      </div>
    </div>
    <button
      data-qa-button="load-more"
      class="load-more button_blue"
      *ngIf="!(pagination$ | async)?.isLastPage"
      (click)="events.paginationChange$.next()"
    >
      {{ 'button.show.more' | translate }}
    </button>
    <ng-template #listIsEmpty>
      <div class="not_found_block" data-qa-block="empty-list">
        <span translate data-qa="empty-list-text">cto.modal.not.found</span>
      </div>
    </ng-template>
  </div>
  <tax-kkms-page-filter
    *ngIf="retailPlaces$"
    (applyFilter)="events.applyFilter$.next()"
    (reloadState)="events.reloadState$.next()"
  ></tax-kkms-page-filter>
</div>
